/**
 * 「我的」页上的入口（I 10-16：放 me 模块，只对能照顾这只宠物的人显示；入口名「TA 的小动作」）。
 * 照 CredentialEntry 的写法：一行 ps-me-row（样式来自 me.css，不另写），去 /me/moves。
 * 出现的条件：live、能力表 pets.teach 开着、这个家里我有照顾权限、有当前宠物；任何一样读不到或不满足，就不出这一行。
 * 小字是本账号的额度（方案 9.1：额度放在教学入口附近、按账号写），只写一行的短说法（6c2b 轻审中 1：同组别的行都是一行），整句留给 /me/moves 顶上；
 * 额度还没读到就只写一句说明，不写数字。
 */
import { Link } from "react-router";
import { Icon } from "@/shared/ui";
import { TEACH_ENTRY_TITLE, entitlementShort } from "./teachModel";
import { useCanCare, useEntitlement, useTeachApi, useTeachOpen } from "./useTeach";

export const TEACH_ENTRY_META = "教 TA 一个你熟悉的小动作";

export function TeachEntry({ petId }: { petId: string | null }) {
  const api = useTeachApi();
  const open = useTeachOpen();
  const canCare = useCanCare();
  const shown = Boolean(api && open && canCare && petId);
  return shown ? <TeachEntryRow /> : null;
}

function TeachEntryRow() {
  const entitlement = useEntitlement();
  return (
    <li>
      <Link to="/me/moves" className="ps-me-row" data-tone="sun" data-teach-entry>
        <span className="ps-me-row__icon" aria-hidden="true">
          <Icon name="sparkle" size={20} />
        </span>
        <span className="ps-me-row__text">
          <span className="ps-me-row__title">{TEACH_ENTRY_TITLE}</span>
          <span className="ps-me-row__meta">{entitlement.data ? entitlementShort(entitlement.data) : TEACH_ENTRY_META}</span>
        </span>
        <Icon name="chevron" size={16} className="ps-me-row__go" />
      </Link>
    </li>
  );
}
